import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconChevronLeftComponent } from "./med-icon-chevron-left.component";

@NgModule({
  declarations: [
    MedIconChevronLeftComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconChevronLeftComponent,
  ],
})
export class MedIconChevronLeftModule { }
